var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgCaretNeutral = function SvgCaretNeutral(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: "caret-neutral_svg__ionicon",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m404 339.178-139.78 163.12a24 24 0 0 1-36.44 0L88 339.178c-13.34-15.57-2.28-39.62 18.22-39.62h279.6c20.5 0 31.56 24.05 18.18 39.62m0-167.238L264.22 8.82a24 24 0 0 0-36.44 0L88 171.94c-13.34 15.57-2.28 39.62 18.22 39.62h279.6c20.5 0 31.56-24.05 18.18-39.62"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCaretNeutral);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;